export interface CartesianValues {
  x: number;
  y: number;
}
/**
 * @param   {number}  centerX         centerX
 * @param   {number}  centerY         centerY
 * @param   {number}  radius          radius
 * @param   {number}  angleInDegrees  angleInDegrees
 * @returns {object}  cartesianValue  cartesianValue
 */
export function polarToCartesian(
  centerX: number,
  centerY: number,
  radius: number,
  angleInDegrees: number
): CartesianValues {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians),
  };
}

/**
 * @param   {number}  percent percent
 * @returns {number}  degree  degree
 */
export function percentToDegree(percent: number): number {
  return (213 + (294 / 100) * percent) % 360;
}

/**
 * @param   {number}  percent       percent
 * @param   {number}  radius        radius
 * @returns {number}  cartesianVal  cartesianValue
 */
export function percentToXYGauge(
  percent: number,
  radius: number
): CartesianValues {
  return polarToCartesian(100, 100, radius, percentToDegree(percent));
}
